import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';

import HeadsetMicRoundedIcon from '@mui/icons-material/HeadsetMicRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';

const HowToUseButton = () => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Tooltip content='Como usar'>
          <Button variant='outlined' color='secondary' size='condensed' icon={<LightbulbIcon />} />
        </Tooltip>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align='end'>
        <DropdownMenu.Item onClick={() => window.open('https://suporte.cobli.co/')}>
          <DropdownMenu.Icon icon={<HelpRoundedIcon />} />
          <DropdownMenu.Label>Central de ajuda</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item onClick={() => window.open('https://app.livestorm.co/cobli-1')}>
          <DropdownMenu.Icon icon={<SchoolRoundedIcon />} />
          <DropdownMenu.Label>Ver treinamentos</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item onClick={() => window.open('https://suporte.cobli.co/contato-cobli')}>
          <DropdownMenu.Icon icon={<HeadsetMicRoundedIcon />} />
          <DropdownMenu.Label>Contato</DropdownMenu.Label>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default HowToUseButton;
